var scope_0 = require('/home/matt/sites/mattanddesign.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/11d66d83282176e9b41eb3300c608668.js').default;
var scope_1 = require('/home/matt/sites/mattanddesign.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/278714943d0af958a539aea710fb858f.js').default;
var scope_2 = require('/home/matt/sites/mattanddesign.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/48529ca7cf67d827704b44a5827be788.js').default;
var scope_3 = require('/home/matt/sites/mattanddesign.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    